<template>
  <div v-if="!loadPage">
    <b-button class="col-12 mb-5"
              variant="outline-success"
              @click="$bvModal.show('createTask')">Aufgabe Erstellen</b-button>
    <b-modal  title="Aufgabe Erstellen"
              id="createTask">
      <h3>Aktion</h3>
      <v-select :options="optionsAction"
                v-model="task.action"
                :clearable="false">
      </v-select>
      <h3>Ausführung</h3>
      <v-select :options="optionsPeriod"
                v-model="task.period"
                :clearable="false">
      </v-select>
      <h3>Erste Ausführung</h3>
      <date-picker
        v-model="task.date"
        locale="de"
        class='date-picker'
      >
      </date-picker>
      <template v-slot:modal-footer>
        <b-button @click="sendTask()">Senden</b-button>
      </template>
    </b-modal>
    <luma-datatable :model="taskModel"
                    :columns="columns"
                    :url="urlC">
    </luma-datatable>
  </div>
</template>

<script>
  import {VserverScheduled} from "@/store/models/vserver/vserver_scheduled";
  import LumaDatatable from "@/components/LumaDatatable";
  import DatePicker from 'v-calendar/lib/components/date-picker.umd'
  import axios from "@/store/vue-axios"
  export default {
    components: {LumaDatatable,DatePicker},
    name: "luma-tasks-vserver",
    props:{loadPage:Boolean},
    data:()=>({
      taskModel:VserverScheduled,
      task:{
        action:'',
        period:'',
        date:''
      },
      taskMap:{
        taskaction: {
          'Start': 'start',
          'Herunterfahren': 'shutdown',
          'Backup erstellen': 'createBackup',
          'Neustart': 'restart'
        },
        taskperiod: {
          'Stündlich':'hour',
          'Täglich':'day',
          'Wöchentlich':'week',
          'Monatlich':'month',
          'Jährlich':'year'
        }
      }
    }),
    computed:{
      vid(){
        return this.$route.params.id
      },
      urlC(){
        return "/datacenter/vservers/"+this.vid+"/scheduledTasks"
      },
      finalTask(){
        if(!this.task) return
        return {
          action:this.taskMap.taskaction[this.task.action],
          period:this.taskMap.taskperiod[this.task.period],
          date:this.task.date
        }

      },
      optionsPeriod(){
        const x = Object.keys(this.taskMap.taskperiod)
        return x
      },
      optionsAction(){
        const x = Object.keys(this.taskMap.taskaction)
        return x
      },
      columns(){
        return [
          {
            key:'created_at',
            column:'created_at',
            filter:true,
            order:true
          },
          {
            key:'next_execution',
            column:'next_execution',
            filter:true,
            order:true
          },
          {
            key:'last_execution',
            column:'last_execution',
            filter:true,
            order:true
          },
          {
            key:'type',
            column:'type',
            filter:true,
            order:true
          }
        ]
      }
    },
    methods:{

      async sendTask(){
        if(!this.finalTask.action && !this.finalTask.period ) return
        this.$bvModal.hide('createTask')
        const x = await axios.post("/datacenter/vservers/scheduled-tasks/create",
          {
            first_execution : this.finalTask.date,
            vserver_id:this.vid,
            action: this.finalTask.action,
            interval:this.finalTask.period
          }
        )
          .then(response=>{
            console.log(response)
          })
          .catch(error=>{
            console.log(error)
          })
      }
    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datacenter/vserver_datacenter/luma-scheduled-tasks-vserver.vue